import type { AccessSession, Role, Session } from '../types/token';

const KEY = 'botianhome.session';
export const SESSION_CLEARED_EVENT = 'botianhome:session-cleared';
const roles: Role[] = ['viewer', 'admin'];

function isObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

function parseAccessSession(value: Record<string, unknown>): AccessSession | null {
  if (
    typeof value.token !== 'string' ||
    typeof value.company !== 'string' ||
    typeof value.role !== 'string' ||
    !roles.includes(value.role as Role)
  ) {
    return null;
  }

  return {
    kind: 'access',
    token: value.token,
    company: value.company,
    role: value.role as Role,
  };
}

export function getSession(): Session | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as unknown;
    if (!isObject(parsed)) return null;

    if (parsed.kind === 'guest') {
      return typeof parsed.company === 'string'
        ? { kind: 'guest', company: parsed.company }
        : null;
    }

    return parseAccessSession(parsed);
  } catch {
    return null;
  }
}

export function setSession(session: Session): void {
  localStorage.setItem(KEY, JSON.stringify(session));
}

export function clearSession(): void {
  localStorage.removeItem(KEY);
  window.dispatchEvent(new Event(SESSION_CLEARED_EVENT));
}
